var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('z-stance',{attrs:{"type":"message","show-info":false,"descText":_vm.info,"img-src":"https://pic4.zhuanstatic.com/zhuanzh/f9436be4-ddfb-4f7b-8047-f0ae914e714c.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }